import "./Omnichannel.module.css";
import CabeceraPrincipal from "@/reusable_sections/Header";
import PbxVtecOmnicanal from "./sections/PbxVtecOmnicanal";
import CapacidadesDelSoftware from "./sections/CapacidadesDelSoftware";
import SolicitarDemo from "./sections/SolicitarDemo";
import PieDePGinaInformativo from "@/reusable_sections/Footer";
import VideoIntroduction from "./sections/VideoIntroduction";
import OmnichannelCapabilities from "./sections/OmnichannelCapabilities";
import ChatComparison from "./sections/ChatComparison";
import AiTranscriptionAnalysis from "./sections/AiTranscriptionAnalysis";
import SurveyFeedbackCapabilities from "./sections/SurveyFeedbackCapabilities";
import PredictiveDialerAutomation from "./sections/PredictiveDialerAutomation";
export default function OmnichannelPage() {
  return <div>
      <CabeceraPrincipal />
      <PbxVtecOmnicanal />
      <VideoIntroduction />
      <OmnichannelCapabilities />
      <AiTranscriptionAnalysis />
      <PredictiveDialerAutomation />
      <ChatComparison />
      <CapacidadesDelSoftware />
      <SolicitarDemo />
      <SurveyFeedbackCapabilities />
      <PieDePGinaInformativo />
    </div>;
}